import { forwardRef } from 'react';
import { Dialog } from '@mui/material';

const AppDialog = forwardRef(function AppDialog({ onClose, ...dialogProps }, ref) {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    onClose(event, reason);
  };

  return (
    <Dialog
      ref={ref}
      {...dialogProps}
      onClose={onClose ? handleClose : undefined}
    />
  );
});

export default AppDialog;
